import React from 'react';
import { GenericTableColumn } from '@ui-components/Table/GenericTable';
import { GenericTag } from '@ui-components/Tag/GenericTag';

export interface IAMPermission {
  id: number;
  permission: string;
  enabled: boolean;
}

export const iamPermissionsColumns: GenericTableColumn<IAMPermission>[] = [
  {
    header: 'Permission',
    accessor: 'permission',
  },
  {
    header: 'Status',
    accessor: 'enabled',
    renderCell: (row: IAMPermission) => (
      <GenericTag
        label={row.enabled ? 'Allowed' : 'Denied'}
        variant={row.enabled ? 'success' : 'error'}
      />
    ),
  },
  {
    header: 'Required',
    renderCell: () => (
      <GenericTag label="Yes" variant="default" />
    ),
  },
];
